import { render, staticRenderFns } from "./TopicCard.vue?vue&type=template&id=1ee5971b&"
import script from "./TopicCard.vue?vue&type=script&lang=js&"
export * from "./TopicCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports